<template>
  <v-card
    class="pa-6 integrations-config-card"
    elevation="0"
  >
    <v-card-title class="text-title">
      1. Configure Your ATS
    </v-card-title>
    <v-card-text class="pa-0 mb-5 my-7">
      <div class="d-flex align-center text-title my-7">
        <img
          :src="logoUrl"
          :alt="`${atsName}_logo`"
          height="34"
          class="mr-4"
        >{{ atsName }}
      </div>

      <div>
        Please review the support documentation on how to enable your
        {{ atsName }} integration:
      </div>
    </v-card-text>
    <a
      :href="guidance"
      target="_blank"
      rel="noopener noreferrer"
    ><strong>Read our Guidance</strong></a>
  </v-card>
</template>

<script>
export default {
  name: 'IntegrationConfigCard',
  props: {
    atsName: { type: String, default: '' },
    guidance: { type: String, default: '' },
    logoUrl: { type: String, default: '' },
  },
};
</script>

<style scoped lang="less">
.integrations-config-card {
  width: calc(50% - 6px);
}
</style>
